import { render, staticRenderFns } from "./tipo_doc.vue?vue&type=template&id=e5289c7c&"
import script from "./tipo_doc.vue?vue&type=script&lang=js&"
export * from "./tipo_doc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports